<template>
  <div>
    <div class="fullscreen-video">
      <video autoplay muted loop playsinline>
        <source src="@/assets/video/haloween.mp4" type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>
      <div class="wrapper fadeInDown">
        <!-- <router-link to="/validacionUsuarios">clickea</router-link> -->
        <!-- <button class="btn btn-light" @click="$router.push('/')">  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-return-left mx-2" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"/>
</svg>REGRESAR AL LOGIN</button> -->
        <div id="formContent" v-if="correo">
          <label v-if="pin" for="" class="mt-3 labeltamaño"
            >Ingresar correo corporativo: 🎃 🎃 🎃 </label
          >
          <div v-if="pin">
            <input
              type="email"
              class="fadeIn second"
              name="login"
              placeholder="Ejemplo: @gruposolimano.com.pe o @people.com.pe"
              v-model="correoenviar"
            />

            <button
              class="btn btn-success ms-2 w-100 mt-2"
              @click="mandarCorreo"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                class="bi bi-envelope"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                />
              </svg> 🦇
            </button>
          </div>

          <!-- <div v-else>
          <h2 class="mt-0">Tiempo de Expiracion {{ tiempo }}</h2>
          <label for="" class="mt-3 labeltamaño">Ingresar PIN:</label>

          <input
            type="text"
            class="fadeIn second"
            name="login"
            placeholder="Ingresar PIN"
            v-model="enviarPin"
          />

          <button class="btn btn-light border border-1" @click="mandarPin">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              class="bi bi-check-circle text-success"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
              />
            </svg>
          </button>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SolimanologHaloween",

  data() {
    return {
      user: {
        usuCodigo: "",
        usuContrasena: "",
      },

      correoenviar: "",

      error: false,
      boton: true,
      correo: true,
      pin: true,
      enviarPin: "",
      recuperarContra: false,
      tiempo: "",
      ojoAbierto: true,
    };
  },

  mounted() {},

  methods: {
    togglePasswordVisibility() {
      const passwordInput = this.$refs.passwordInput;

      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        this.ojoAbierto = !this.ojoAbierto;
      } else {
        passwordInput.type = "password";
        this.ojoAbierto = !this.ojoAbierto;
      }
    },

    validatePassword() {
      // Expresión regular para permitir solo letras y números
      const regex = /^[A-Za-z0-9]+$/;
      if (!regex.test(this.user.usuContrasena)) {
        // Elimina caracteres no permitidos
        this.user.usuContrasena = this.user.usuContrasena.replace(
          /[^A-Za-z0-9]/g,
          ""
        );
      }
    },

    MandarOlvido() {
      this.$router.push("/validation");
    },

    iniciarContador() {
      // Crea un intervalo que actualiza el tiempo cada segundo
      setInterval(() => {
        if (this.tiempo > 0) {
          this.tiempo--;
        } else {
          // Cuando el tiempo llega a 0, muestra el mensaje

          location.reload();
        }
      }, 1000); // Actualiza cada segundo
    },

    mandarCorreo() {
      const from = {
        conCorreo: `${this.correoenviar}`,
      };
      this.axios
        .post(`Webscraping/RegistrarClientes` , from)
        .then((r) => {
        //   console.log(r.data);
            if (r.data) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: " 🎃Ojos de sapo, patas de rana... ¡Qué tengas suerte toda la semana! ¡Te registraste con éxito! 🎃",
                showConfirmButton: true,
                // timer: 3200,
              });
              this.correoenviar = "";
             
            } else {
              Swal.fire({
                icon: "error",
                title: " 🎃CORREO INCORRECTO 🎃",
                text: "",
                footer: "",
              });
              this.correoenviar = "";
            }
        })
        .catch((error) => {
        //   console.log(error.response.data);
          if (error.response.data) {
            Swal.fire({
              icon: "error",
              title: ' 🎃"Todos nos volvemos un poco locos en Halloween" ¡Ya te encuentras registrado!🎃',
              text: "",
              footer: "",
            });
            this.correoenviar = "";
          }
        });
    },

    mandarPin() {
      this.axios
        .get(`Values/VerificarToken?token=${this.enviarPin}`)
        .then((r) => {
          console.log(r.data);
          this.recuperarContra = true;
          this.correo = false;
        });
    },

    login() {
      console.log("funciona");

      this.axios
        .post(
          `Values/RestablecerContrasena?dni=${this.user.usuCodigo}&nuevaContrasena=${this.user.usuContrasena}`
        )
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Contraseña actualizada con éxito",
              showConfirmButton: false,
              timer: 1200,
            });
            this.tiempo = 0;
            this.$router.push("/");
          } else {
            Swal.fire({
              icon: "error",
              title: "DNI INCORRECTO",
              text: "",
              footer: "",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.fullscreen-video {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  object-fit: cover;
}

video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.95; /* Ajusta la opacidad según tus preferencias (0.0 - 1.0) */
  filter: blur(1px); /* Ajusta la cantidad de desenfoque */
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7); /* Fondo semi-transparente */
  z-index: 1; /* Asegúrate de que el formulario esté sobre el video */
}

.form-container {
  /* Estilos para el formulario, por ejemplo, centrarlo */
  text-align: center;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
}
.tamaño {
  font-size: 1.25rem;
  font-weight: 700;
}
.labeltamaño {
  /* background: darkcyan; */
  width: 325px;
  text-align: left;
  font-weight: 700;
  color: #39ace7;
  font-size: 1.15rem;
  width: 100%;
  margin-left: 1.38rem;
}
body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}
.curso {
  cursor: not-allowed;
}
a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}
h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}
/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  /* justify-content: center; */
  width: 100%;
  min-height: 100vh;
  padding: 15px;
  /* background: #ffffff; */
}
#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 25px;
  width: 100%;
  max-width: 650px;
  position: relative;
  margin-top: 190px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  /* text-align: ; */
}
#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}
/* TABS */
h2.inactive {
  color: #cccccc;
}
h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}
/* FORM TYPOGRAPHY*/
input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #39ace7;
}
input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}
input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}
input[type="number"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 100%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}
input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}
input[type="text"]:placeholder {
  color: #cccccc;
}

input[type="password"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 100%;
  border: 3px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}
input[type="password"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}
input[type="password"]:placeholder {
  color: #cccccc;
}

input[type="email"] {
  background-color: #f6f6f6;
  border: none;
  color: hsl(0, 0%, 5%);
  padding: 10px 30px;
  text-align: left;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 100%;
  border: 3px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}
input[type="email"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}
input[type="email"]:placeholder {
  color: #cccccc;
}
/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}
.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.fadeIn.fourth {
  -webkit-animation-delay: 0.1ms;
  -moz-animation-delay: 0.1ms;
  animation-delay: 0.1ms;
}
/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}
.underlineHover:hover {
  color: #0d0d0d;
}
.underlineHover:hover:after {
  width: 100%;
}
/* OTHERS */
*:focus {
  outline: none;
}
#icon {
  width: 79%;
  height: 160px;
  border-radius: 20px;
  opacity: 0.9;
  margin-bottom: 20px;
}
</style>
